module.exports = __webpack_public_path__ + "static/media/charge-speed.6ec1d1fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/charge-speed.png
// module id = 766
// module chunks = 0